// Route Paths
export const ROUTE_PATHS = {
  HOME: '/',
  CONTRACTORS: '/contractors',
  CAREERS: '/careers',
  INVESTMENT: '/investment',
} as const;

// Company Info
export const COMPANY_INFO = {
  name: 'أنظمة المباني المبتكرة',
  abbr: 'IBS',
  fullName: 'شركة أنظمة المباني المبتكرة للمقاولات',
  tagline: 'نبني الفخامة... نسلّم الإتقان',
  description: 'متخصصون في بناء الفنادق الفاخرة في المنطقة المركزية بالمدينة المنورة، نقدم خدمات متكاملة من الحفر والأساسات حتى التشطيبات النهائية وتسليم المفتاح.',
  location: 'المدينة المنورة، المملكة العربية السعودية',
  owners: ['الشيخ أسامة المسعود', 'شركة ون للاستثمار'],
  phone: '+966 56 662 2223',
  email: 'info@1investment.com.sa',
  website: 'one-investment.com',
  vision: 'أن نكون الشريك المفضّل للمطورين العقاريين وصناديق الاستثمار في تنفيذ مشاريع الفنادق الفاخرة بالمدينة المنورة، مع الحفاظ على أعلى معايير الجودة والاستدامة.',
  mission: 'تنفيذ مشاريع البناء الفندقي الفاخرة بكفاءة عالية وفي الوقت المحدد، من خلال فريق هندسي وفني متخصص وشبكة واسعة من مقاولي الباطن والموردين المعتمدين.',
  social: {
    instagram: 'https://www.instagram.com/oneinvement/',
    twitter: 'https://x.com/oneinvement',
    whatsapp: 'https://wa.me/966566622223',
    linkedin: 'https://linkedin.com',
  },
} as const;

export const STATS = [
  { value: 20, suffix: '+', label: 'مشروع منجز' },
  { value: 10, suffix: '+', label: 'سنة خبرة' },
  { value: 100, suffix: '+', label: 'مقاول معتمد' },
  { value: 100, suffix: '%', label: 'التزام بالجودة' },
];

export interface Service { icon: string; title: string; description: string; items: string[]; }
export interface Strength { icon: string; title: string; description: string; }
export interface Project { title: string; location: string; type: string; status: string; image: string; }
